import termsAndConditionsAr from "./terms-conditions-ar";

const delivery = `ديليفري`;
const dineOut = `خروجات`;
const experiences = `أخبار الأكيلة`;
export const arContent = {
  companyCorborate: {
    promptMessage: "أوردر في الشغل؟",
    promptDesc: "استمتع بعروض حصرية و أوردر مع زمايلك في الشغل",
    selectCompany: "اختار شركتك",
    skip: "تخطي",
    bannerMessage: "استمتع بعروض حصرية في شركتك",
    orderTo: "انت بتأوردر في "


  },
  referral:{
 title:'افتح اللينك من موبايلك و خد خصم 50 جنيه',
 description:'افتح اللينك من موبايلك عشان تستفيد من عروض المكافئات علي المنيوز',
 goBackHome:'ارجع للصفحة الرئيسية',
 referralDiscount:'خصم الصحاب',
 freeQuestion:'تاكل ببلاش؟',
 inviteTxt:'شجع اصحابك الأكيلة يستخدموا المنيوز واكسب فلوس',
 download:'حمل الابلكيشن دلوقتي',
  },
  business:{
    title:"المنيوز بيزنس",
    subtitle:'يلا نزل الابليكيشن من الستور و استمتع بأحلي تجربة أوردر للأكل!',
    description:"افتح اللينك من موبايلك و اشترك في برنامج مكافأت شركتك, متضيعش الفرصة انك تستمتع بتجربة مليانة عروض وتخفيضات لأكتر أكل بتحبه!",
   },
  feedBanner:{
    fstTxt:'إستمتع بخصم حتى',
    scndTxt:'50%',
    thirdTxt:'',
    download:'حمل الابلكيشن دلوقتي',
    enjoy:''
  },
  common: {
    priceLater:'بناءًا على مكانك',
    home:'الرئيسية',
    breadCrumbrestaurants:'مطاعم',
    to:'إلى',
    areas:'مناطق',
    cities:'مدن',
    dishes:'اطباق',
    aboutUs:'عنا',
    termsConditions:'الأحكام والشروط',
    careers:'وظائف',
    joinelmenus:'انضم لنا',
    elmenus:'المنيوز مصر',
    privacy:'الخصوصية',
    onlineOrdering: 'اوردر اونلاين',
    liveTracking: "متابعة الاوردر",
    limitedTracking: "تتبع محدود",
    trackOrder: 'تابع الاوردر',
    tastyOffers: `عروض شهية`,
    dishDiscovery: `اكتشف الاصناف المميزة`,
    applyOffer: 'استخدم العرض',
    offerApplied: 'العرض مستخدم',
    discountsAbove: 'عرض على الاوردرات الاكتر من',
    discountsAll: 'عرض على كل الاوردرات',
    dineout: dineOut,
    delivery: delivery,
    experiences: experiences,
    orderOnline: `اوردر اونلاين`,
    orderOnlineNow: `اوردر اونلاين`,
    installNow: `تثبيت الابليكيشن`,
    acceptPromo: `يقبل برومو`,
    acceptCreditCard: `يقبل الدفع بالكريدت كارد`,
    doesntAcceptCreditCard: `المطعم لا يقبل الدفع بالكريدت كارد`,
    downloadApp:'نزل ابليكيشن المنيوز',
    downloadAppSubTitle:'اكتشف و أوردر الأكل الي هتحبه',
    unavailableInAreaRightNow: (area) => `غير متاح في ${area} <br/> حتى الأن`,
    downloadTheApp: `حمل الابلكيشن`,
    noDeliveryHere: `لا يوجد توصيل هنا`,
    sorry: `للأسف`,
    egp: `جنيه`,
    taxes: `ضرائب`,
    close: `إغلاق`,
    back: `رجوع`,
    change: `تغيير`,
    addNew: 'إضافة جديد',
    changeAddress:'تغيير المكان',
    and: `و`,
    choose: `اختار`,
    select: `اختار`,
    zone: `الحي`,
    area: `المنطقة`,
    city: `المدينة`,
    in: `في`,

    hours: `ساعات`,
    days:"ايام",
    minutes: `دقائق`,
    mins: `دقيقه`,
    support: `مساعدة`,
    edt: `هيوصل في`,
    reviews: `تقييم`,
    ratings:'تقييم',
    unavailable: `غير متاح`,
    unavailableInBranch:(itemName,branchName)=>`يرجى العلم ان ${itemName} غير متاح فى فرع ${branchName}`,
    unavailableForDelivery: `غير متاح للديليفري`,
    unavailableForDeliveryImgError: `يرجى العلم انه غير متاح للتوصيل`,
    currentlyUnavailableImgError: `يرجى العلم انه غير متاح حاليا`,
    unavailableInBranchImgError:"يرجى العلم انه غير متاح فى الفرع",
    noOnlineOrdering:`عفوًا! هذا المطعم غير متاح للطلب اونلاين`,
    currentlyUnavailable: `غير متوفر`,
    timeAvailabilityMessage: (timeFrom = "", toTime = "") =>
      `متوفر من الساعة ${timeFrom} الي الساعة ${toTime}`,
    sortBy: `ترتيب`,
    helpful: `مفيد`,
    readMore: `المزيد`,
    readLess: `اقل`,
    workingHours: `ساعات العمل`,
    openNow: `مفتوح الآن`,
    closedNow: `مغلق الآن`,
    open: `مفتوح`,
    closed: `مغلق`,
    availableShortly: "سيكون متاحًا قريبًا",
    closedToday: `مغلق اليوم`,
    tempClosed: `غير متاح`,
    openingIn: `هيفتح خلال`,
    opensIn: `هيفتح خلال`,
    opensAt: `هيفتح في`,
    opensTomorrow: `هيفتح بكرة في`,
    closesIn: `هيقفل خلال`,
    min: `على الأقل`,
    max: `على الأكثر`,
    required: `مطلوب`,
    inMaadiOnly: `في المعادي فقط`,
    subTotal: `إجمالي الأصناف`,
    tax: `ضريبة`,
    deliveryFee: `تكلفة التوصيل`,
    serviceFee: `رسوم الخدمة`,
    feesToolTipTitle:`شرح رسومنا`,
    walletDiscount: `المدفوع بمحفظة المنيوز`,
    total: `إجمالي`,
    cash: `كاش`,
    wallet: `المحفظة`,
    topup: "شحن المحفظة",
    topupInfo: `عايز تدفع اونلاين ومفيش رصيد كفاية؟ دوس علي "شحن المحفظة" علشان تقدر تزود رصيد بالمحفظة!`,
    edit: `تعديل`,
    delete: `مسح`,
    enterDeliveryLocation: `إختار منطقتك`,
    creditCards: {
      VISA: "Visa",
      MASTERCARD: "Master card",
      AMEX: "Amex",
      MADA: "Mada"
    },
    fieldNames:{
      card_number:'رقم الكارت',
      expiry_date:' تاريخ صلاحية الكارت',
      card_security_code:'الكود السري'
    },
    exit: `خروج`,
    paymentMethod: `طريقة الدفع`,
    choosePayment: `اختار طريقة الدفع`,
    elmenusWallet: "محفظة المنيوز",
    currentCredit: "الرصيد المستخدم: ",
    cashOnDelivery: `كاش`,
    cashNotAvailableforRestaurant:'المطعم ده مش بيقبل الدفع بالكاش',
    creditCard: `بطاقة ائتمان`,
    noCreditCard: `(ليس لديك بطاقة ائتمان)`,
    CASH_ON_DELIVERY: `كاش`,
    CASH_ON_DELIVERYSimple: `كاش`,
    CREDIT_CARDSimple: `بطاقة`,
    CREDIT_CARD: `بطاقة ائتمان`,
    addCardBtn: 'اضافة بطاقة ائتمان جديدة ',
    addCardTitle: 'اضافة بطاقة جديدة',
    cardNum: 'رقم الكارت',
    cardName: 'الإسم على البطاقة (اختياري)',
    cvv: 'الرقم السري',
    cancel:'إلغاء',
    addCardSuccess: 'تم اضافة الكارت بنجاح',
    addCardGenericError: 'حدث خطأ أثناء إضافة البطاقة، برجاء إعادة المحاولة',
    estimatedDelivery: `متوسط وقت التوصيل`,
    shortName: {
      estimatedDelivery: 'الوقت',
      CASH_ON_DELIVERY: `كاش`,
      CREDIT_CARD: `بطاقة`,
    },
    estimatedDeliveryIftar: `الاوردر بتاعك هيوصل على الفطار`,
    IftarWarning: `المطعم بيوصل على الفطار بس`,
    afterIftarWarning: `وقت الفطار عدى، هتقدر تعمل اوردر فطار بكرة`,
    deliverNow: `التوصيل دلوقتي`,
    deliverIftar: `التوصيل على الإفطار`,
    deliveryTimesPrompt: {
      title: "هل انت متأكد انك تريد المتابعة؟",
      submit: "تابع"
    },
    deliveryAddress: `عنوان التوصيل`,
    apply: `تطبيق`,
    orderTotal: `إجمالي الأوردر`,
    seeAll: `رؤية الكل`,
    discover: `إكتشف`,
    restaurants: `مطعم`,
    all: `كل الأطباق`,
    more: `اخرين`,
    showLess: `أظهر أقل`,
    searchAllLocations: `إبحث في كل المناطق`,
    searchCities: `ابحث في المدن`,
    searchAreas: `ابحث في المناطق`,
    searchZones: `ابحث في الأحياء`,
    yourLocation: `موقعك`,
    discount: `خصم`,
    optional: `إختياري`,
    gotIt: `فهمت`,
    dontAskAgain: `لا تسأل مجدداً`,
    am: 'صباحاً',
    pm: 'مساءاً',
    noResultsHere: `للأسف لا يوجد نتائج`,
    updateAddress: 'النقطة اللي انت اخترتها جديدة, انت متأكد ان عاوز تغير  عنوانك؟',
    yesBtn: 'نعم',
    noBtn: 'لا',
    addNewAddress: 'اضف عنوان جديد',
    deliveryTimeShorten: 'التوصيل',
    passwordValidation: {
      characters: 'كلمة السر لازم تحتوي على حروف كبيرة و صغيرة',
      symbolsAndNumbers: 'كلمة السر لازم تحتوي على أرقام و رموز',
      length: 'كلمة السر لازم تكون على الأقل من 8 إلى 16 حرف'
    },
    savedAddresses: "العناوين المحفوظة",
    newAddress: "حدد موقع جديد",
    businessLabel:"عروض الشركات",
    flashTimer:"متبقي"
  },
  expirCard: {
    verifyCard: `تأكيد تاريخ صلاحيةالبطاقة`,
    title: (card) => `عشان تقدر تعمل اوردر بالكارت الآتي #** ${card} يرجي تأكيد تاريخ نهاية صلاحية الكارت`,
    month: 'الشهر',
    year: 'السنة',
    confirm: 'تأكيد'
  },
  addCreditCard: {
    errors: {
      "00003": 'نوع بطاقتك غير مدعوم',
      "00012": 'البطاقة منتهية الصلاحية',
      "00016": 'رقم البطاقة غير صالحة',
      "00029": 'رصيد غير كاف',
      "00100": 'تاريخ انتهاء الصلاحية غير صالح', 
      "13666":'تم رفض المعاملة',
      "3": 'نوع بطاقتك غير مدعوم',
      "12": 'البطاقة منتهية الصلاحية',
      "16": 'رقم البطاقة غير صالحة',
      "29": 'رصيد غير كاف',
      "100": 'تاريخ انتهاء الصلاحية غير صالح', 
      "666":'تم رفض المعاملة',
      'popUpError':'يرجي تمكين الموقع من فتح نوافذ اخرى و إعادة المحاولة',  
    }
  },
  walkThrow: {
    title: 'دلوقتي ممكن تعمل أوردر مع صحابك',
    step1Title: '١. ابعت اللينك',
    step1Desc: 'لكل اللي هيعملوا الأوردر معاك.',
    step2Title: '٢. دوس على اوردر',
    step2Desc: 'لما كله يزود أوردراته',
    step3Title: '٣. شوف التقسيمة',
    step3Desc: 'على كل واحد كام.',
  },
  header: {
    chooseCityLocation: `اختار مدينتك`,
    or: 'أو',
    detectLocation: 'حدد موقعي',
    browserPermission: "يرجي اعطاء المتصفح الاذن",
    enableBrowser: "باين انك مش مديلنا مكانك, ممكن تستخدم خاصية البحث عشان تلاقي شركتك",
    couldentDetectArea: "منطقتك للأسف معرفنهاش ممكن تكتب او تختار منطقتك",
    couldnotDetectLocation: "للأسف الموقع اللي انت اختارته خارج نطاق خدمتنا",
    outOfPolygon: `خلي بالك, انت برا الحي اللي انت اخترته, ممكن منقدرش نوصل طلبك`,
    chooseArea: "اختار المنطقة",
    chooseZone: "اختار الحي",
    loginWithEmail: `أو سجل بالإيميل`,
    signupWithEmail: `أو سجل بالإيميل`,
    discoverAndOrder: `اكتشف واوردر الاكل الي بتحبه ❤️`,
    email: `الايميل`,
    password: `كلمة السر`,
    name: `الاسم`,
    login: `تسجيل الدخول`,
    logIn: `تسجيل الدخول`,
    signup: `حساب جديد`,
    createAccount: `حساب جديد`,
    logout: `تسجيل الخروج`,
    forgotPassword: `نسيت كلمة السر؟`,
    signIn: `تسجيل الدخول بحساب`,
    signUp: `سجل بحساب `,
    continueWithFacebook: `الفيس بوك`,
    loginWithGoogle: `جوجل`,
    youAgree: `أوافق علي`,
    termsOfService: `شروط الخدمة`,
    privacyPolicy: `الخصوصية`,
    accountSettings: `إعدادات الحساب`,
    yourProfile: `حسابك`,
    hello: `اهلا`,
    myFavorites: `مطاعمي المفضلة`,
    myOrders: `أوردراتي`,
    orderTracker: `متابعة الأوردر`,
    leaderBoard: `سباق الأكيلة`,
    advertiseWithUs: `أعلن معنا`,
    addYourMenu: `أضف المنيو`,
    giveUsFeedback: `قولنا رأيك`,
    aboutElmenus: `عن المنيوز`,
    careers: `وظائف`,
    viewBasket: `إظهار الأوردر`,
    yourBasketIsEmpty: `قائمة الاوردر فارغة`,
    noOnlineOrderingHere: ` الأونلاين أوردر غير متاح في الفرع`,
    OnlineOrderingIn: `اونلاين أوردر في`,
    deliverTo: `بيوصّل الى`,
    deliver: `بيوصّل `,
    dineOutIn: `خروجات في`,
    welcomeBack: `اهلا`,
    notifications: {
      title: `إشعارات`,
      noNotifications: `لا يوجد إشعارات`,
      earlier: `سابقًا`,
      new: `جديد`,
      yourOrderFrom: `الأوردر بتاعك من`
    },
    chooseYourDeliveryLocation: `إختار منطقتك`,
    chooseLocation: `إختار منطقة`,
    loginFirst: `برجاء تسجيل الدخول أولا`,
    loginFirstDesc: `علشان تبتدي الأوردر`,
    loginFirstDescToShare: `علشان تبتدي الأوردر دة`,
    sendPromo: `اكلة هدية`,
    offers:'العروض'

  },
  landingPage: {
    whatYouCraving: `دور علي اي مطعم`,
    discoverAndOrder: `إكتشف وأوردر أحلى الأكلات`,
    giftingMsg: `ابعت اكلة هدية لصحابك و زمايلك في الشغل `,
    tryNow: `جرب دلوقتي`,
    orExplore: `أو إكتشف المنيوز`,
    go: `ديليفري`,
    deliveryLink: {
      title: delivery,
      description: `افضل مطاعم بتوصّل حواليك`
    },
    dineoutLink: {
      title: dineOut,
      description: `إكتشف مطاعم حسب نوع الخروجة أو نوع الأكل أو المنطقة`
    },
    nowYouCan: `دلوقتي تقدر تـ`,
    trackYourOrder: {
      title: `تابع الأوردر لحد ما يوصلك`,
      description: `دلوقتي تقدر تعرف الاوردر بتاعك بيتحضر ولا في الطريق لحد ما يوصل ليك.`
    },
    noPhonecalls: {
      title: `من غير تليفونات`,
      description: `اوردر الأكل اللي بتحبة أسرع وأسهل ومن غير تليفونات.`
    },
    lookingForDelivery: `بتدور علي الدليفيري؟`,
    lookForRestaurants: `دور علي المطاعم اللي عليها `
  },
  orderTracking: {
    trackingStates: [
      `في انتظار رد المطعم`,
      `الأوردر بيتحضر`,
      `الأوردر خرج في الطريق`,
      `الأوردر وصل`
    ],
    placedAt: `إتعمل`,
    seeOrderDetails: `تفاصيل الأوردر`,
    yesIReceived: `الأوردر وصل`,
    myOrder: ``,
    orderStatus: {
      PENDING: {
        name: `في إنتظار رد المطعم`,
        bannerStep: 1,
        message: (restaurantName) => `تم ارسال الاوردر بتاعك من ${restaurantName}.`,
        note: "و في إنتظار رد المطعم"
      },
      ROUTED: {
        name: `في إنتظار رد المطعم`,
        bannerStep: 1,
        message: (restaurantName) => `تم ارسال الاوردر بتاعك من ${restaurantName}.`,
        note: "و في إنتظار رد المطعم"
      },
      INSPECTING: {
        name: `في إنتظار رد المطعم`,
        bannerStep: 1,
        message: (restaurantName) => `تم ارسال الاوردر بتاعك من ${restaurantName}.`,
        note: "و في إنتظار رد المطعم"
      },
      SEEN: {
        name: `في انتظار رد المطعم`,
        bannerStep: 1,
        message: (restaurantName) => `تم ارسال الاوردر بتاعك من ${restaurantName}.`,
        note: "و في إنتظار رد المطعم"
      },

      ACCEPTED: {
        name: `الأوردر بيتحضر`,
        bannerStep: 2,
        message: (restaurantName) => `الاوردر بتاعك من ${restaurantName} بيتحضر.`,
        note: ""
      },

      OUT_FOR_DELIVERY: {
        name: `الأوردر خرج في الطريق`,
        bannerStep: 3,
        message: (restaurantName) => `الاوردر بتاعك من ${restaurantName} في طريقه ليك.`,
        note: ""
      },
      RAMADAN: {
        name: "الأوردر بيتحضر",
        bannerStep: 2,
        message: (restaurantName) => `الاوردر بتاعك من ${restaurantName} هيتحضر لما نقرب عالفطار.`,
        note: ""
      },
      DELIVERED: {
        name: `الأوردر وصل`,
        bannerStep: 4,
        message: (restaurantName) => `اوردرك من ${restaurantName} المفروض يكون وصل ليك`,
        note: ""
      },
      REJECTED: {
        name: `المطعم رفض الأوردر`,
        bannerStep: "reject",
        message: (restaurantName) => `${restaurantName} رفض الأوردر `,
        note: ""
      },
      CANCELED: {
        name: `تم إلغاء الأوردر`,
        bannerStep: "cancel",
        message: (restaurantName) => `تم إلغاء الأوردر من ${restaurantName}`,
        note: ""
      }
    }
  },
  filters: {
    more:'أكثر',
    less:'اظهر أقل',
    selectedFilters: `الفلتر`,
    filters: `الفلتر`,
    clearAll: `إلغاء`,
    showResultsFor: `عرض نتائج:`,
    filterBy: `فلتر:`,
    onlineOrderingOnly: `أوردر أونلاين`,
    quickDelivery: `توصيل سريع`,
    onlinePayment: `دفع أونلاين`,
    openNow: `مفتوح الآن`,
    hygiene: 'فحص النظافة',
    promo: `عروض`,
    results: `نتائج`,
    apply: `تطبيق`,
    popular: `الأكثر شهرة`,
    rating: `الأعلى تقييماً`,
    latest: `الأجدد`,
    deliveryTime: `الأسرع في التوصيل`
  },
  discoverySearch: {
    emptyStates: {
      onlineOrderingNoRestaurants: `خدمة الاوردر اونلاين عير متاحة في منطقتك حالياً`
    },
    company: {
      searchYourCompany: 'ابحث عن شركتك',
      orderingAtWork: 'بتأوردر وانت فى الشغل؟',
      companyDesc: ' هيجيلك عروض حصرية ليك انت و صحابك في الشغل!',
      selectCompany: 'اختار شركتك',
      emptyCompanies: 'باين انك في مكان ثاني, استخدم خاصية البحث عشان تلاقي شركتك',
      loadingNearby: 'جاري البحث عن شركات جنبك',
      startSearching: 'استخدم شريط البحث أعلاه للعثور على شركتك.',
      offersTitle: 'عروض حصرية ل ',
      locationNotSupported: 'موقعك الحالي غير مدعوم في عالم المنيوز',
      enableLocation: 'حاول تاني',
      notSupported: 'الشركة اللي انت اخترتها لسه مش مدعمة من المنيوز'

    }
  },
  restaurant: {
    fopModal: {
      title: `ممكن تعمل اوردر من علي الابليكيشن`,
      offerTitle: `اوردر اونلاين و استمتع بالعرض`,
      offlineTitle: `تقدر تكلم المنيوز عشان تعمل اوردر و تتابعه!`,
      callRestaurant: `كلم المطعم`,
      callAndTrackOrder: `كلم المنيوز و تابع اوردرك`,
      orderfromElmenus: `اوردر بالتليفون`,
      orderfromRestaurant: `اوردر من المطعم`,
      creditDesc: ' ادفع اونلاين',
      trackingDesc: 'تتبع اوردرك على الخريطة',
      timeDesc: ' وفر وقت • تجنب مكالمات مركز الاتصال الطويلة.',
      orderOnline: 'اوردر اونلاين',
      getPromo:'استمتع بالعرض',
      getApp:'نزل ابليكيشن المنيوز',
      callAnyway: 'اتصل',
      firstPromo: (value) => `خصم ${value} جنيه علي اي اوردر اعلي من 100 جنيه`,
      firstDiscount: (value) => `خصم ${value}% علي اي اوردر اعلي من 100 جنيه`
    },
    onlineMenuUnavailable:'قائمة المطعم غير متوفرة',
    resHasNoMenu:'هذا المطعم ليس لديه قائمة طعام حتى الآن على المنيوز.',
    loadingMenus:"يتم تحميل قائمة المطعم",
    loadingMenuCats:"يتم تحميل أقسام قائمة",
    itemTooltip: 'دلوقتي! كل الي مفروض تعمله انك تضيف الاطباق علي اوردرك!',
    checkMore: 'مطاعم تانية ممكن تعجبك ',
    checkMoreOnline: 'تقدر تعمل أوردر أونلاين من  ',
    useCoupon: ` استخدم `,
    expires: `ينتهي :`,
    discountOnOrdersAbove: 'خصم على الاوردرات الاعلى من',
    general: `المطعم`,
    menu: `المنيو`,
    scannedMenu: `المنيو المصور`,
    info: `بيانات`,
    about: `عن المطعم`,
    branches: `الفروع`,
    photos: `الصور`,
    reviews: `التقييمات`,
    addReview: {
      selectBranch: 'اختر فرع المطعم',
      rating: 'تقييمك للمطعم',
      outOfFive: '/5',
      textAreaHalfOne: 'شارك تجربتك في مطعم ',
      textAreaHalfTwo: 'وساعد الناس تستفيد من تجربتك`',
      textAreaMinLetters: 'على الاقل 40 حرف',
      uploadPhotoBtn: 'شارك صور (اختياري)',
      shareReview: 'شارك التقييم',
      uploadModal: {
        title: 'رفع الصور',
        selectPhoto: 'اختار الصور',
        emptyPhotoTitle: `انت لسة مخترتش صور `,
        emptyPhotoDesc: `يللا ابدأ حط صور واربطها بالأكلة اللي تحبها`,
        selectItemToTag: 'اختار أكلة عشان تعملها تاج'
      },
      cancel: 'إلغاء',
      continue: 'استمرار',
      close: 'قفل',
      addReview: 'ضيف تقييم',
      confirmationModal: {
        titleAfterSuccess: 'التقييم اتضاف بنجاح',
        titleAfterFail: 'التقييم متضفش',
        descAfterSuccess: 'شكرًا على تقييمك',
        descAfterFail: 'حاجة حصلت غلط, حاول مرة تانية',

      }

    },
    viewScannedMenu: `شوف المنيو المصور`,
    searchInMenu: `دور علي اكلة`,
    resultsFor:  `الاكلات اللي دورت عليها `,
    emptyResult: (dishName) => `مفيش اكلات بالاسم دا  "${dishName}"، جرب تدور تاني`,
    onlineMenu: `اونلاين منيو`,
    fullAlbum: `كل الصور`,
    nowYouCanOrderOnline: `أوردر أونلاين على`,
    doesNotOfferOnlineOrdering: `الأونلاين أوردر غير متاح في الفرع`,
    restaurantNotOrderToThisArea: (restaurantName) => `${restaurantName} لا يقدم خدمة الطلب اونلاين في هذه المنطقة`,
    noOnlineOrderingInAreaYet: (areaName) => `الطلب اونلاين غير متاح في  ${areaName}`,
    trackYourOrder: `تابع الأوردر لحد ما يوصلك`,
    noPhoneCalls: `من غير تليفونات`,
    yourDeliveryLocation: `إختار منطقتك`,
    enterYourLocationToCheck: (restaurantName = "") =>
      `إختار منطقتك عشان تعرف ${restaurantName} بيوصلّك أو لأ`,
    basketIsEmpty: `ابدأ الاوردر دلوقتي`,
    onlineOrderingIn: `اوردر اونلاين في`,
    noDeliveryIn: `مش بيوصلك`,
    noOnlineCallNow: `اوردر بالتليفون`,
    resOrBranchNotDeliver: "اوردر بالتليفون",
    willBeBack: `اوردر بالتليفون`,
    notDeliverToYou: (restaurantName = "") => `${restaurantName} مش بيوصل لمنطقتك`,
    deliversToYou: `بيوصل ليك`,
    deliversTo: `بيوصل ل`,
    notDeliver: (restaurantName = "") => `مش بيوصل دلوقتي ${restaurantName}`,

    noOrdering: (restaurantName = "") => `${restaurantName} لا يقدم خدمة الطلب اونلاين`,
    deliverByPhone: `المطعم بيوصلك من خلال التليفون`,
    noOrderingInBranch: `هذا الفرع لا يقدم خدمة الطلب اونلاين`,
    deliversToYouDescription: `المطعم بيوصل لعنوانك`,
    notDeliverToSelectedArea: `المطعم مش بيوصل لعنوانك`,
    deliversToSelectedArea: `المطعم بيوصل لعنوانك`,
    checkNow: `تأكد`,
    loadMoreRestaurants: `تحميل مطاعم أكثر`,
    phoneNumber: `أرقام تليفونات المطعم`,
    selectNumber: `اختار رقم تتصل بيه`,
    call: `اتصل`,
    menuTab: {
      deliveryTime: `وقت التوصيل`,
      topDishes: `أحسن الأطباق`,
      offers: `العروض`,
      deliveryfees: `تكلفة التوصيل`,
      minOrder: `الحد الادنى`,
      deliveryHours: `ساعات التوصيل`,
      menus: `المنيوز`,
      add: `أضف`,
      menuAvailableFrom: `المنيو متاحة فقط من `,
      to: `إلي`
    },
    scannedMenuTab: {
      title: `المنيو المصور`
    },
    photosTab: {
      featuredPhotos: `صور المطعم`,
      communityPhotos: `صور الأكيلة`,
      loadMorePhotos: `شوف صور أكثر`
    },
    reviewsTab: {
      noReviewsYet: `لا يوجد تقييمات`,
      loadMoreReviews: `تحميل تقييمات أكثر`
    },
    branchesTab: {
      searchBranches: `إبحث في الفروع`,
      more: `أكتر`,
      less: `أقل`,
      features: `مميزات`,
      tags: `أنواع الخروجات`
    },
    infoTab: {
      title: `بيانات`,
      address: `العنوان`
    },
    itemModal: {
      addToBasket: `أضف`,
      specialinstructions: `تعليمات خاصة`,
      specialinstructionsPlaceholder: `مثال: بدون بصل`,
      selectSize: `إختار حجم`,
      sizes: `الأحجام`,
      updateItem: `تعديل`
    },
    areaZoneModal: {
      canDeliverToThoseAreas: `بيوصل لهذه المناطق`
    },
    basket: {
      promoMinNotReached: (remainingValue) => `فاضل ${remainingValue} جنيه عشان تستمتع بالعرض`,
      memberItemError: `في مشكلة في شوية اطباق `,
      groupOrder: `أوردر مع أصحابك`,
      orderLocked: `الأوردر اتقفل`,
      friendsCantAdd: `صحابك مش هيقدروا يغيروا في الأوردر`,
      memberLockedBanner: {
        title: `الأدمن قفل الأوردر`,
        desc: `مش هتقدر تغير في  الأوردر`,
      },
      unlockBtn: `افتح الأوردر تاني`,
      items: `الأطباق`,
      taxsDelivery: `شامل الضريبة والتوصيل`,
      includeTaxDelivery: "شامل الضريبة والتوصيل",
      emptyTitle: `الجروب أوردر لسه فاضي `,
      emptyDesc: `أضف أطباقك المفضلة الأن `,
      unlockFailMessageTitle: `آسفين!`,
      unlockFailMessageBody: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
      deleteBasketConfirm: `متأكد إنك عايز تلغي الجروب أوردر؟`,
      deleteBasketDesc: `لو لغيت الجروب أوردر، كل طلباتك وطلبات أصحابك هتتلغي`,
      deleteBasketBtn: `إلغي الجروب أوردر`,
      leaveBasketBtn: `إمشي من الجروب أوردر`,
      leaveBasketConfirm: `متأكد انك عايز تمشي من الجروب أوردر؟`,
      leaveBasketDesc: `لو مشيت من الجروب أوردر، أطباقك هتتلغي`,
      bulkRemoveConfirm: `الاوردر بتاعك فيه أطباق مش موجودة دلوقتي`,
      bulkRemoveAllConfirm: `كل الأطباق في الاوردر بتاعك مش موجودة دلوقتي`,
      bulkRemoveAllDesc: `مش هتقدر تكمل بالأطباق دي`,
      bulkRemoveDesc: `المتابعة هتمسح الأطباق دي`,
      bulkRemoveBtn: `متابعة`,
      bulkRemoveAllBtn: `امسح الاوردر`,
      yourOrder: `الأوردر`,
      deliveringTo: `توصيل الي`,
      goCheckout: `متابعة`,
      removeAll: `مسح كل الأطباق`,
      deleteBasket: `حذف الاوردر`,

      cancelGroup: `إلغي الجروب أوردر`,
      shareGroup: `ابعت الجروب لأصحابك `,
      extras: `إضافات`,
      comment: `تعليمات خاصة`,
      comments: `تعليمات خاصة`,
      removeItem: `مسح الطلب من الأوردر`,
      remove: `مسح`,
      backToMenu: `الرجوع إلى المنيو`,
      myBasket: `الأوردر`,
      orderDetails: `تفاصيل الأوردر`,
      qty: `الكمية`,
      new: `جديد!`,
      convertDesc: `دلوقتي ممكن تعمل أوردر مع أصحابك`,
      groupOrderDesc: `دلوقتي تقدر تعرف تعمل أوردر مع أصحابك:
      1- ابعت اللينك لأصحابك عشان تعملوا أوردر سوا
      2- أعمل الأوردر لما كل الناس تزود الأوردرات بتاعتهم
      3- أعرف حساب كل واحد كام`,
      groupOrderSummary: 'دلوقتي ممكن تعملوا أوردر مع بعض',
      groupOrderShareDesc: `شير اللينك مع أصحابك أو زمايلك، واعمل الأوردر.`,
      copyToClipBoard: `نسخة من اللينك`,
      copyPromo: `نسخ البرومو`,
      copied: `معاك نسخة من اللينك`,
      promoCopied: `تم نسخ البرومو`,
      orderBelowMinimum: (minValue) => ` قيمة الطلبات أقل من الحد الأدنى للأوردر ${minValue} جنيه`,
      loadingYourBasket: ` تحميل الاوردر`,
      loadingYourAddresses: ` تحميل عناوينك`,
      discardGroupBasketTitle: `انت عندك جروب اوردر تاني من مطعم`,
      discardGroupBasketDesc: `متأكد انك عايز تمسح الجروب اوردر التاني و تبدأ أوردر جديد؟`,
      discardGroupBasketBtn: `موافق، امسح الجروب اوردر التاني`,
      discardBasketTitle: `انت عندك أوردر تاني من مطعم`,
      discardBasketDesc: `متأكد انك عايز تمسح الأوردر التاني و تبدأ أوردر جديد؟`,
      discardBasketBtn: `موافق، امسح الاوردر التاني`,
      leaveBasketErrorTitle: `انت عضو في جروب اوردر تاني من مطعم`,
      leaveBasketErrorDesc: `متأكد انك عاوز تسيب الجروب اوردر التاني وتبدأ اوردر جديد`,
      leaveBasketErrorBtn: `موافق، سيب الاوردر التاني`,
      thankYou: `شكراً`,
      orderPlaced: `الجروب أوردر إتعمل`,
      tryGroups: `جرب الجروب اوردر`,
      orderWithFriends: `دلوقتي تقدر تعمل اوردر مع صحابك`,
      groups: `جروب`,
      start: `ابدأ`,
      startGroup: 'ابدأ جروب',
      share: 'شارك',
      NOW: 'دلوقتي!',
      errors: {
        BRANCH_UNAVAILABLE_DESC: 'الفرع غير متاح حاليا لعمل اوردر اونلاين',
        RESTAURANT_UNAVAILABLE_DESC: 'المطعم غير متاح حاليا لعمل اوردر اونلاين',
        ITEM_UNAVAILABLE_IN_BRANCH: "في أطباق مش موجودة دلوقتي",
        ITEM_UNAVAILABLE_NOW: "في أطباق مش موجودة دلوقتي",
        ITEM_UNAVAILABLE_FOR_DELIVERY: "في أطباق مش متوفرة للتوصيل دلوقتي",
        ITEM_PRICE_CHANGE: "في الاطباق سعرها اتغير",
        BRANCH_CLOSED: "الفرع مقفول",
        SORRY: "اسفين",
        BRANCH_CLOSED_DESC: "المطعم هيفتح تاني قريب",
        DISCOVER_OPEN_RESTAURANTS: "اكتشف المطاعم المفتوحة دلوقتي",
        DISCOVER_DELIVERING_RESTAURANTS: "اكتشف مطاعم بتوصلك",
        BRANCH_NO_DELIVER: "الفرع مش بيوصل دلوقتي",
        BRANCH_NO_COVER: "الفرع ده مش بيغطي منطقتك",
        RESTAURANT_NO_COVER: "المطعم ده مش بيغطي منطقتك",
        ORDER_BELOW_MINIMUM: "قيمة الأوردر اقل من الحد الأدني ",
        GENERIC_ERROR: "حصل مشكلة، ممكن تحاول تاني كمان شوية؟",
        GENERIC_ERROR_DESC: "",
        NO_INTERNET: "مفيش إتصال بإنترنت",
        PLEASE_CHECK_INTERNET: "ممكن تتأكد من إتصالك بانترنت",
        TRY_AGAIN: "حاول تاني",
        RETRY: "حاول تاني",
        CANCEL: "الغاء",
        NO_LONGER_ACTIVE: "الأوردر خلاص مش موجود",
        LOCKED: "الاوردر اتقفل، مش هتقدر تغير في الأوردر ",
        apologizeMessage: 'آسفين على أي ازعاج اتسببلك.. دوس ع الزرار اللي تحت عشان تشوف مطاعم تانية بتوصلك'

      },
      itemErrors: {
        ITEM_UNAVAILABLE_IN_BRANCH: "الطبق مش متوفر حالياً",
        ITEM_UNAVAILABLE_NOW: "غير متوفر",
        ITEM_UNAVAILABLE_FOR_DELIVERY: "الطبق مش متاح للتوصيل",
        ITEM_PRICE_CHANGE: "السعر اتغير"
      },
      itemRetryErrors: {
        add: `حصل مشكلة في اضافة`,
        remove: `حصل مشكلة في حذف`,
        edit: `حصل مشكلة في تعديل`,
        create: `حصل مشكلة في اضافة`,
        cancel: `الغاء`,
        retry: `حاول تاني`
      }
    },
    checkout: {
      steps: {
        step1: "عنوان التوصيل",
        step2: "مراجعة الأوردر"
      },
      flatDiscountMsg: (value) => `ليك ${value} جنيه خصم على الأوردر`,
      percentDiscountMsg: (value) => `ليك ${value} % خصم على الأوردر`,
      remove: `حذف`,
      checkout: `خلص الأوردر`,
      addAddress: `زود عنوان جديد`,
      deliverToThisAddress: `إختار العنوان ده`,
      setDefault: `عنواني الأساسي`,
      restDoesntDeliver: (restaurantName = "") =>
        ` مش بيوصل للعنوان ده ${restaurantName}`,
      reviewOrder: `راجع الأوردر`,
      mustPlaceOrder: `الأوردر مش هيتعمل غير لما تضغط على "أوردر دلوقتي"`,
      promoCode: `برومو كود`,
      enterPromo: `إكتب البرومو كود هنا`,
      items: `الطلبات`,
      placeOrderAction: `أوردر دلوقتي`,
      orderSummary: `ملخص الأوردر`,
      exitCheckout: `الخروج`,
      review: `مراجعة`,
      orderConfirmation: `تأكيد الأوردر`,
      thankYouConfirm: `الأوردر إتعمل، شكراً`,
      emailConfirm: `هنبعتلك إيميل بتفاصيل الأوردر.`,
      yourOrderNumber: `رقم الأوردر`,
      toRedeemPromoCondition: `عشان تستخدم البرومو كود لازم قيمة الأوردر تبقى أكتر من`,
      enterCodeHere: `دخل البرومو كود`,
      promoErrors: {
        NOT_FOUND: `البرومو غير صحيح`,
        EXPIRED: `البرومو انتهى`,
        USER_NOT_ASSIGNED: `البرومو غير متاح لك`,
        REDEEMED: `انت استخدمت البرومو ده قبل كده`,
        FIRST_ORDER_ONLY: `البرومو متاح لأول اوردر فقط`,
        RESTAURANT_NOT_ACCEPTING: `للأسف المطعم ده مش بيقبل برومو`,
        RESTAURANT_NOT_ASSIGNED: `للأسف المطعم ده مش بيقبل برومو ده`,
        EXCEED_BUDGET: `هذا البرومو غير متاح حالياً`,
        BELOW_PROMO_MINIMUM_ORDER_VALUE: (minValue) => `الاوردر لازم يكون علي الاقل ${minValue} عشان تستمتع بالبرومو `,
        SOMETHING_WRONG: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
        ExceedBudget: `هذا البرومو غير متاح حالياً`,
        SamePromoGroupUsedBefore: `لا يمكنك استخدام هذا البرومو`,
        AddressNotInPromoArea: `هذا برومو متاح في (اسم المنطقة) فقط`,
        ExceedNumberOfUsage: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
        EXCEED_NUMBER_OF_USERS: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
        PROMO_ABUSED: `انت استخدمت البرومو ده قبل كده`,
        NOT_STARTED: `البرومو غير متاح الان`,
        SAME_PROMO_GROUP_USED_BEFORE: `لا يمكنك استخدام هذا البرومو`,
        ADDRESS_NOT_IN_PROMO_AREA: `هذا برومو غير متاح في منطقتك`,
        EXCEED_NUMBER_OF_USAGE: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
        INVALID_PROMO_PAYMENT_TYPE: `البرومو لحاملي البطاقات الائتمانية فقط`,
        GROUP_ORDER_ONLY: `اليرومو للجروب اوردر فقط`,
        BELOW_MINIMUM_GROUP_USERS_COUNT: `انت اقل من الحد الادني للعدد اللي معاك في الجروب عشان تستخدم البروموكود`,
        FIRST_N_ORDER_ONLY: (maxNumberOfUsagePerUser) => `البرومو كود ده للأوردرات الأولى، بس احنا لسه عندنا عروض تانيه علشان الأكل اللي بتحبه`,
        PROMO_WITH_MEAL_DISCOUNT: `المطعم لا يقبل البروموكود مع وجبات التوفير`,
        USER_NUMBER_IS_NOT_ORANGE:`الكود دا مش ساري علي رقم تليفونك`,
        INVALID_PROMO_PAYMENT_PREFIX: `البرومو مش شغال علي الكارت البنكي دا`,
        BASKET_IS_LOCKED: `Sorry the Order is locked you can't do any changes `
      }
    },
    addressForm: {
      currentOrderAddress:{
        building:'مبنى: ',
        floorNumber:'رقم الدور',
        apt:'شقة:'
      },
      outOfCoverage: 'خارج نطاق خدمتنا',
      personalInfo: `البيانات الشخصية`,
      name: `الإسم`,
      namePlaceholder: `مثال: شادي جمال`,
      phoneNo: `رقم الموبايل`,
      phoneNoPlaceholder: `مثال: 01654238764`,
      notCallYou: `مش هنكلمك إلا لو فيه مشكلة في الأوردر.`,
      selectMap: `من فضلك إختار مكانك على الخريطة عشان نعرف نوصلك أسرع.`,
      streetAddress: `العنوان`,
      streetText: `مثال: شارع الحرية`,
      building: `رقم المبنى`,
      buildingText: `مثال: ٤`,
      apartment: `رقم الشقة`,
      apartmentText: `مثال: ١٤`,
      floor: `رقم الدور`,
      floorText: `مثال: ٢`,
      landmark: `إسم الشارع`,
      landmarkText: `مثال: أمام فندق كرنفاال`,
      companyAddress: `عنوان شركة؟`,
      companyName: `إسم الشركة`,
      saveDefault: `التسجيل كعنواني الأساسي`,
      pleaseClickHere: `إضغط هنا`,
      mapEmpty: `من فضلك إختار مكانك على الخريطة عشان نعرف نوصلك أسرع.`,
      saveAddress: `تسجيل العنوان`,
      cancel: `إلغاء`,
      leave: `مغادرة`,
      errors: {
        name: `دخل الإسم صح`,
        addressInfo: `دخل عنوان صح`,
        buildingNumber: `دخل رقم مبنى صح`,
        floorNumber: `دخل رقم طابق صح`,
        apartmentNumber: `دخل رقم الشقة صح`,
        mobile: `دخل رقم جوال صح`,
        company: `دخل اسم شركة صح`
      },
      yourLocation: "موقعك"
    },
    notifications: {
      notifications: `إشعارات`,
      earlier: `إشعارات سابقة`,
      new: `جديد`,
      emptyNotification: `لا يوجد إشعارات.`
    },
    shareOrder:{
      title: 'مشاركة الاوردر',
      description: `شارك أطباق الأوردر مع أصدقائك`
    },
    sharedOrder:{
      orderPage: `طلب متشارك`,
      friendThinks:`شايف انك هتحب الاوردر دة`,
      from:'من',
      items:'أطباق',
      extra:'اضافات',
      comment:'تعليق',
      subTotal: `إجمالي الأصناف`,
      total:'إجمالي',
      placeOrder:'ابدأ الأوردر',
      addEdit:"ضيف أو غير الأوردر",
      addEditMessage:{
        _1st:'تقدر',
        _2nd:' تضيف و تغير',
        _3rd:' من الاصناف الي في الاوردر علشان تطلب من المطعم زي ما انت عاوز '
      }
    },

    myOrders: {
      iftar:'الفطار',
      total: 'إجمالي',
      estimatedDelivery: 'وقت التوصيل',
      yourOrderFrom: 'الاوردر بتاعك من',
      deliveringYourFood: (driverName) => `${driverName} جايلك في الطريق بأكلك`,
      orderId: 'رقم الأوردر',
      eta: 'الوقت',
      restaurantName: 'restaurantArName',
      hasBeenHeld: 'متعطل!',
      cancelOrder: 'إلغاء الأوردر',
      payCash: "الدفع كاش",
      changeCard: "جرب كارت تاني",
      updateResume: 'تعديل و تكملة الأوردر',
      resumeError: 'حصل خطأ، حاول مرة تانية',
      IFTAR: 'افطار',
      NOW: 'دلوقتي',
      myOrders: `أوردراتي`,
      trackOrder: `تابع الاوردر بتاعك`,
      current: `حالي`,
      previous: `سابق`,
      yourOrderfrom: `أوردر من`,
      yourGroupOrderfrom: `أوردر من`,
      groupOrderfrom: `أوردر من`,
      groupOrderInvite: `تم دعوتك للمشاركة في جروب اوردر`,
      groupOrderJoinedMembers: ` في الجروب اوردر `,
      includeTaxDelivery: "شامل الضريبة و التوصيل",
      emptyCurrentMain: `لا يوجد أوردرات حالية.`,
      emptyCurrentNote: `تقدر تشوف الأوردرات الحالية هنا`,
      emptyPreviousMain: `لا يوجد أوردرات`,
      emptyPreviousNote: `إكتشف أحلى الأكلات.`,
      emptyPreviousAction: (areaName = "") => `مطاعم بتوصل لمنطقة ${areaName}.`,
      wantToDiscover: ` إكتشف أحلى الأكلات و إعمل أوردر دلوقتي`,
      exploreMore: `استكشف مطاعم تانية`,

      startOrderingNow: `إعمل أول أوردر ليك`,
      orderItems: `أطباق`,
      currentOrders: `أورداراتك الحالية`,
      previousOrders: `أوردراتك السابقة`,
      currentOrdersEmpty: `لا يوجد أوردرات حالية`,
      previousOrdersEmpty: `لا يوجد أوردرات سابقة`,
      ReorderBtn: `اوردر تاني`,
      shareOrderBtn:'مشاركة الأوردر',
      loadMore: 'تحميل اوردرات اكتر',
      order: 'الأوردر',
      noReorderMessage: 'اوردر تاني للجروب لسة موصلش',
      cancelOrderModalTitle: 'الغاء الأوردر',
      cancelOrderModaldesc: 'سبب الإلغاء',
      cancelOrderMsg: "تم إلغاء الأوردر",
      cancelOrderErrorMsg: "للأسف مش هينفع نلغي الاوردر بتاعك",
      confirm: 'تأكيد',
      cancelModal: {
        CANCELED_ORDER_DELAYED: 'طلبي يستغرق وقتًا طويلاً',
        CANCELED_CHANGED_MY_MIND: 'غيرت رأيي',
        CANCELED_FOUND_BETTER_OFFER: 'وجدت عرض احسن',
        CANCELED_CHANGED_MY_ADDRESS: 'لقد غيرت عنواني',
        CANCELED_OTHER: ' سبب اخر'
      },
      rejectionReasons: {
        REJECTED_ADDRESS_NOT_CLEAR: "عنوانك مش واضح لعامل التوصيل",
        REJECTED_ADDRESS_OUT_OF_COVERAGE: "عنوانك مش واضح لعامل التوصيل",
        REJECTED_INSUFFICIENT_FUNDS: "يبدو أن بطاقة الائتمان الخاصة بك لا تملك أموالًا كافية"
      },
      yourRunner: "اسم الطيار",
      driverStates: {
        accepted: (driverName) => `${driverName} وافق على الأوردر و في طريقه للمطعم`,
        readyForPickup: (driverName) => `${driverName} وصل المطعم و في انتظار إستلام الأوردر`,
        outForDelivery: (driverName) => `${driverName} 😋 إستلم اوردرك و في طريقه ليك`,
      }
    },
    delivery:{
      discoverDishes: `إكتشف الأكلات`,
      dishes:"الأكلات",
      offers:'اقوى العروض على الأوردر أونلاين',
      
dishRestaurants:(dishName)=>`مطاعم ${dishName}`
          },
    dineout: {
      dineoutHeader: `إكتشف الخروجات`,
      discoverMoods: `إكتشف الخروجات`,
      discoverDishes: `إكتشف الأكلات`,
      discoverArea: (areaName = "") => `إكتشف ${areaName}`,
      hiddenGems: `مطاعم لازم تكتشفها`,
      newRestaurants: `مطاعم جديدة`,
      moods: `خروجات`,
      categories: `أقسام`,
      dishes: `الأكلات`
    },
    toolTips: {
      orderingTipHeader: `إكتشف مطاعم الأوردر أونلاين`,
      orderingTipBody: `دوس على الزرار ده عشان تشوف المطاعم اللي بتقدم خدمة الأوردر أونلاين`,
      menuTipHeader: `أضف أصناف للأوردر`,
      menuTipBody: `عشان تضيف أصناف للأوردر إضغط على علامة الزائد`
    },
    userProfile: {
      yourProfile: `حسابك`,
      editProfile: `تعديل الحساب`,
      reviews: `تقييمات`,
      photos: `صور`,
      followers: `متابِعون`,
      following: `متابَعون`,
      follow: `تابع`,
      loadMoreReviews: `تحميل تقييمات أكثر`,
      emptyReviews: `تقييماتك هتظهر هنا.`,
      accountSettings: `إعدادات الحساب`,
      changeEmail: `تغيير الإيميل`,
      changePassword: `تغيير كلمة السر`,
      genericError: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
      oldPassError: `لقد ادخلت كلمة سر غير صحيحة، حاول مرة اخرى`,
      addressBook: `دفتر العناوين`,
      oldPassword: `كلمة السر القديمة`,
      oldPasswordText: `أدخل كلمة القديمة`,
      newPassword: `كلمة السر الجديدة`,
      newPasswordText: `أدخل كلمة السر الجديدة`,
      confirmNewPassword: `تأكيد كلمة السر الجديدة`,
      confirmNewText: `أدخل كلمة السر الجديدة`,
      show: `إظهار`,
      hide: `إخفاء`,
      emptyPassword: `أدخل كلمة السر`,
      saveChanges: `تسجيل التغييرات`
    }
  },  
  cvm: {
    specialOffers: 'عروض خاصة ليك',
    usePromoCode: 'استخدم برومو كود'
  },
  gifting: {
    steps: {
      step1: "تفاصيل",
      step2: "الدفع"
    },
    cashPayement: "تحويل بنكي مع المنيوز",
    title: "اكلة هدية من المنيوز",
    individualSubtitle: "لو انت شركة و نفسك تبعت برومو كود لموظفينك ",
    corporateSubtitle: "لو عايز تبعت برومو كود هدية لصحابك ",
    clickHere: "اضغط هنا",
    amount: "قيمة الهدية",
    amountInfo: "حدد قيمة البرومو اللي عايزه لكل شخص.",
    amountPlaceholder: "السعر",
    name: "اسم البرومو الهدية",
    namePlaceholder: "مثال VF-",
    paymentMethod:'اختار طريقة الدفع',
    individualNameInfo: "اكتب اسم برومو مكون من 5 ل 10 حروف اللي حابب يوصل لصحابك في رسالة.",
    corporateNameInfo: "اكتب اسم برومو مكون من 5 ل 10 حروف اللي حابب يوصل لموظفينك في رسالة.",
    msg: "رسالة لمستلم الهدية",
    msgPlaceholder: "ارسل رسالة نصية خاصة مع الهدية",
    phones: "ارقام التليفون(ات)",
    individualPhones:'تليفون(ات) مستلم الهدية',
    corporatePhones:' ارقام تليفون موظفينك',
    phonesInfo: "ممكن تدخل كذا رقم تليفون و لازم يكون بيبتدي ب01 و يكون 11 رقم.",
    phonePlaceholder: "01xxxxxxxxx , 01xxxxxxxx",
    phone: "رقم تليفونك",
    companyPhone: "رقم تليفون الشركة",
    companyEmail: "إيميل الشركة",
    companyName: "اسم الشركة",
    sendPromos:'ارسال',
    total:'القيمة بالكامل',
    promoSummary:'تفاصيل الدفع',
    promoValue:'قيمة الهدايا',
    promo:'هدية',
    currency: "جم",
    goToPayment: "التوجه للدفع",
    formPageTitle:{
      individual:'ابعت اكلة هدية لصحابك - اكلة هدية من المنيوز',
      corporate:'فرح موظفينك بأكلة هدية - قسائم شراء من المنيوز'
    },
    formPageDescription:{
      individual:`مفيش هدية احلي من هدية الاكل ان تهديها للي بتحبهم. اعزمهم علي اكلة و زود عليها رسالة مخصصة مع الهدية ساعدهم يكتشفوا بيها اكلات من علي المنيوز`,
      corporate:`كافئ موظفيك على شغهلم بأكلة هدية يحبوها من علي المنيوز. حافظ علي وجود موظفينك وسعادتهم من خلال اكلة هدية من المنيوز مخصصة برسالة إلى فريقك في العمل`,
    },
    phoneValidation: {
      required: "يرجى ادخال ارقام التليفونات .",
      regex: "خلي بالك! في ارقام تليفونات مكتوبة غلط و مش هيتبعتلهم الهدية.",
      duplicates: "خلي بالك! في ارقام تليفونات مكتوبة زي بعض.",
    }
  },
  tinder:{
    likes:'إعجاب',
    show:'مشاهدة',
    egb:'جنيها'

  },
  joinGuest: {
    head: 'دخَّل اسمك!',
    desc: 'دخَّل اسمك عشان تعرف تدير الطلب الجماعي بسهولة',
    guestValidation: 'الاسم لازم يكون حروف وارقام بس',
    start: 'ابدأ',
    or: 'أو',
    createAccount: 'اعمل حساب جديد',
    login: 'سجل دخولك على حساب موجود'

  },
  checkout: {
    peopleView: {
      failMessageTitle: "حدث خطأ",
      failMessageBody: "يُرجى المحاولة مرة أخرى",
      loader: "تحميل بيانات الطلب",
      items: "الطلبات",
      people: "الأشخاص"


    },
    placeOrderErrors: {
      SUCCESS: `SUCCESS`,
      EMPTY_ORDER: `لا يوجد اصناف كافية بالاوردر`,
      INVALID_NEW_STATE: `حصلت مشكلة في الأوردر، من فضلك حاول تاني`,
      INVALID_ITEM_QUANTITY: `من فضلك راجع الأوردر و حاول تاني`,
      RESTAURANT_UNAVAILABLE: `المطعم مش بيستقبل أوردارات دلوقتي، من فضلك حاول كمان شويه`,
      MENU_UNAVAILABLE: `المطعم مش بيستقبل أوردرات دلوقتي، من فضلك حاول كمان شويه`,
      BELOW_MINIMUM_ORDER_VALUE: (value) => `${value ? 'لازم الاوردر يكون علي الافل' + value + 'جنيه، من فضلك راجع الأوردر' : 'الأوردر بتاعك اقل من الحد الأدني للأوردر، من فضلك راجع الأوردر' }`,
      ITEMS_UNAVAILABLE: `بعض الاصناف غير متوفرة دلوقتي، من فضلك راجع الأوردر وحاول تاني`,
      CATEGORIES_UNAVAILABLE: `بعض الاصناف غير متوفرة دلوقتي، من فضلك راجع الأوردر و حاول تاني`,
      INVALID_ROUTING_METHOD: `الفرع مش بيستقبل أوردرات حالياً، حاول تاني كمان شويه`,
      INVALID_EXTRAS: `بعض الأصناف غير متوفرة دلوقتي، من فضلك راجع الأوردر و حاول تاني`,
      PAYMENT_FAILED: `حصلت مشكلة في سحب ثمن الأوردر من بطاقة الائتمان ، حاول تاني كمان شوية`,
      CASH_PAYMENT_UNAVAILABLE:"المطعم ده مش بيقبل الدفع بالكاش", 
      PENDING: `حصلت مشكلة في الأوردر، من فضلك حاول تاني`,
      FAILED: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
      BRANCH_UNAVAILABLE:` المطعم مغلق للتوصيل الان`,
      DUPLICATE_ORDER: "حصلت مشكلة في الأوردر، من فضلك حاول تاني",
      GENERAL_FAIL: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
      INVALID_DELIVERY_TIME_IFTAR: "وقت الفطار عدى، هتقدر تعمل اوردر فطار بكرة",
      INVALID_DELIVERY_TIME_NOW: "المطعم بيوصل علي الفطار بس!",
      NOT_FOUND: `البرومو غير صحيح`,
      EXPIRED: `البرومو انتهى`,
      USER_NOT_ASSIGNED: `البرومو غير متاح لك`,
      REDEEMED: `انت استخدمت البرومو ده قبل كده`,
      FIRST_ORDER_ONLY: `البرومو متاح لأول اوردر فقط`,
      RESTAURANT_NOT_ACCEPTING: `للأسف المطعم ده مش بيقبل برومو`,
      RESTAURANT_NOT_ASSIGNED: `للأسف المطعم ده مش بيقبل برومو ده`,
      EXCEED_BUDGET: `هذا البرومو غير متاح حالياً`,
      BELOW_PROMO_MINIMUM_ORDER_VALUE: (minValue) => `الاوردر لازم يكون علي الاقل ${minValue} عشان تستمتع بالبرومو `,
      SOMETHING_WRONG: `حصل مشكلة، ممكن تحاول تاني كمان شوية؟`,
      ExceedBudget: `هذا البرومو غير متاح حالياً`,
      SamePromoGroupUsedBefore: `لا يمكنك استخدام هذا البرومو`,
      AddressNotInPromoArea: `هذا برومو غير متاح في منطقتك`,
      ExceedNumberOfUsage: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
      EXCEED_NUMBER_OF_USERS: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
      PROMO_ABUSED: `انت استخدمت البرومو ده قبل كده`,
      NOT_STARTED: `البرومو غير متاح الان`,
      SAME_PROMO_GROUP_USED_BEFORE: `لا يمكنك استخدام هذا البرومو`,
      ADDRESS_NOT_IN_PROMO_AREA: `هذا برومو غير متاح في منطقتك`,
      EXCEED_NUMBER_OF_USAGE: `تم استخدام هذا البرومو أكتر من الحد المسموح`,
      INVALID_PROMO_PAYMENT_TYPE: `البرومو لحاملي البطاقات الائتمانية فقط`,
      CARD_BLOCKED: `الكارت بتاعك اتقفل, كلم الدعم عشان تحل المشكلة`,
      LOCATION_PIN_UNAVAILABLE: `عشان نعرف نوصلك الاوردر اسهل حدد مكانك ع الخريطة`,
      GROUP_ORDER_ONLY: `اليرومو للجروب اوردر فقط`,
      BELOW_MINIMUM_GROUP_USERS_COUNT: `انت اقل من الحد الادني للعدد اللي معاك في الجروب عشان تستخدم البروموكود`,
      FIRST_N_ORDER_ONLY: (maxNumberOfUsagePerUser) => `البرومو كود ده للأوردرات الأولى، بس احنا لسه عندنا عروض تانيه علشان الأكل اللي بتحبه`,
      PROMO_WITH_MEAL_DISCOUNT: `المطعم لا يقبل البروموكود مع وجبات التوفير`,
      USER_NUMBER_IS_NOT_ORANGE:`الكود دا مش ساري علي رقم تليفونك`,
      INVALID_PROMO_PAYMENT_PREFIX: `البرومو مش شغال علي الكارت البنكي دا`
    },
    verifyCardErrors: {
      WRONG_EXPIRY_DATE: 'تاريخ الصلاحية مش صح',
      NO_REMAINING_VERIFICATION_ATTEMPTS: `تم حظر الكارت. يرجي تغيير طريقة الدفع`
    },
    verifyPhone: {
      verifyError: "رقم التأكيد غلط حاول تاني"
    }
  },
  toolTips: {
    delivery: {
      step1: {
        tourTitle: "اكتشف مطاعم بتقدم خدمة الطلب اونلاين",
        tourContent: "شغل السويتش عشان تشوف المطاعم اللي بتقدم خدمة اوردر اولاين"
      }
    }
  },
  firstOrderPromo: {
    promoBanner: {
      get: `استمتع بخصم`,
      price: `50 جنيه`,
      desc: 'علي اول اوردر ليك ب100 جنيه علي المنيوز. دخل بروموكود',
      promoName: `FIRST50`,
      promoScreen: 'و انت بتحاسب. ',
      action: 'دوس هنا عشان تبتدي'
    },
    promoDescription: (restaurantName = "") =>
      `استمتع بخصم 50 جنيه علي اول اوردر ليك ب100 جنيه من ${restaurantName}. دخل بروموكود FIRST50 قبل ما تبعت الاوردر`,
    callAnyway: "اتصل",
    toolTip: {
      header: "احصل علي 50 جنيه خصم على اول اوردر ليك ب100 جنيه من المنيوز",
      content: "دوس هنا عشان تشوف مطاعم بتقدم خدمة الطلب اونلاين و تبدأ اول اوردر ليك الأن",
      letsOrder: "اوردرالان"
    }
  },
  smartBanner:{
    install: `تحميل`,
  },
  three30Promo: {
    get: `Get`,
    price: `30 EGP`,
    desc: 'خصم 50 جنيه علي اي اوردر اعلي من 100 جنيه',
    promoName: `THREE30`,
  },
  login: {
    loginError: "يوجد خطأ بالايميل او كلمة المرور"
  },
  dishFeedback: {
    skip: 'تخطي',
    message: 'قولنا أخبار الأكل ايه من',
    showMore: 'عرض أطباق أكتر',
    done: 'تم',
    thanks: 'شكرًا',
    thanksDesc: 'انك شاركتنا برأيك'

  },
  hygeine: {
    name: 'فحص النظافة',
    head: 'تم فحص النظافة!',
    desc: 'رحنا للمطعم و اتأكدنا ان مطبخ المطعم عنده كل المستلزمات اللازمة لبيئة نظيفة حرصا على جودة الاكل!',
    gotIt: 'فهمت'

  },
  giftingPage: {
    section1: {
      title: "مفيش هدية اجمل من إنك تعزم",
      subTitle: "صحابك او موظفينك في الشغل على الأكل",
      desc: "عشان كده عملنا خدمة جديدة و هي 'أكلة هدية' طريقة بسيطة تبسط بيها صحابك و موظفينك إنك تبعتلهم برومو هدية يطلبوا بيه الأكل اللي بيحبوه",
      teams: "ابعت هدية لموظفينك",
      individuals: "ابعت هدية لصحابك"
    },
    section2: {
      title: "كون سبب الابتسامة علي وشوش صحابك او موظفينك",
      amount: {
        title: "اختار قيمة الهدية",
        desc: "حدد ميزانيتك لكل هدية (على سبيل المثال 10 جنيه)."
      },
      friends: {
        title: "دخل رقم او ارقام التليفون",
        desc: "بسهوله هتقدر تدخل أرقام الموبيل عشان تبعت هدية لكل شخص من موظفينك او صحابك."
      },
      pay: {
        title: "ادفع اونلاين",
        desc: "اول ما تدفع المبلغ اونلاين ، هييجي لصحابك رسالة نصية قصيرة تحتوي على رمز الهدية و هيجيلك منا رسالة تأكيد عبر البريد الإلكتروني لعملية الشراء."
      },
      gifts: {
        title: "وصلت الهديه",
        desc: "هييجي لصحابك رمز الهدية في رسالة نصية و يقدروا يستخدموا الهدية علي المنيوز برقم التليفون اللي انت سجلته."
      },
    },

    successmessagebox: {
      maintitle: "شكرا لطلبك",
      secondTitle: "تم قبول طلبك",
      Content: (count,total)=> `تم ارسال ${count} برومو كود هدية لعدد ${count}  رقم موبايل بمبلغ ${total} جنيه `,
      
    },
    waitingmessagebox: {
      maintitle: "هنكلمك عشان نـأكد الطلب معاك",
      secondTitle: "الهدايا لسه متبعتتش لموظفينك",
      Content: (count,total)=> "هنكون بنكلمك عشان نساعدك في عملية تحويل بنكية علي حسابنا علشان نبدأ نبعت الهدايا",
     
    },
  },
  tracking:{
    pinError:'تعذر تحديد موقعك ، يرجى سحب العلامة على الخريطة لتعيين موقعك ',
    pinLocation:'حدد موقعك لتسليم أسرع',
    confirm:'تأكيد',
    skip:'تخطي إلى التتبع'
  },
  tripTracking: {
    trackingStates: [
      `الأوردر خرج في الطريق`,
      `الأوردر وصل`
    ],
    tripStatus: {
      OUT_FOR_DELIVERY: {
        name: `في الطريق`,
        message: `الاوردر جايلك دلوقتي في الطريق`
      },
      DELIVERED: {
        name: "الاوردر وصل",
        message: `بنتمنالك وجبة سعيدة`
      }
    }
  },
  topup: {
    creditAmount: `رصيد المحفظة`,
    remainingCredit: (value) => `الحساب الباقي للأوردر هو  ${value} جنيه`,
    chargeYourWallet: `اشحن المحفظة للأوردارات الجاية كمان، تقدر تحدد المبلغ انه يكون الباقي من الأوردر أو أكتر`,
    selectCard: `اختار الكارد`,
    tapOncardtoModifiy: `اضف أو اختار الكادر عشان تشحن بيه المحفظة`,
    addCard: `أضف كارد جديد`,
    btn: `اشحن الرصيد ده`,
    errors:{
      BASKET_LOCKED: "حصل مشكلة في الأوردر ، اتصل بالمسئول عن الجروب و حاول مرة تانية",
      BASKET_CANCELED: "حصل مشكلة في الأوردر ، اتصل بالمسئول عن الجروب و حاول مرة تانية",
      INVALID_BASKET: "حصل مشكلة في الأوردر ، اتصل بالمسئول عن الجروب و حاول مرة تانية",
      MISSING_USER_EMAIL: "حصل مشكلة في الأوردر ، اتصل بالمسئول عن الجروب و حاول مرة تانية",
      INVALID_CARD: "حصل مشكلة في الدفع بالكار بتاعك اضف أو اختار كارد تاني و حاول مرة تانية",
      CARD_BLOCKED: `حصل مشكلة في الدفع بالكار بتاعك اضف أو اختار كارد تاني و حاول مرة تانية`,
      INSUFFICIENT_FUNDS: "حصل مشكلة في الدفع بالكار بتاعك اضف أو اختار كارد تاني و حاول مرة تانية",
      NO_WALLET_FOUND: "حصل مشكلة في الأوردر ، اتصل بالمسئول عن الجروب و حاول مرة تانية",
      GENERIC_ERROR: "حصل مشكلة، ممكن تحاول تاني كمان شوية؟"
    },
    success: "الرصيد اتشحن بنجاح",
    confirmModal: {
      title: (value) => `شحن المحفظة برصيد ${value} جنيه`,
      yesBtn: "ايوه",
      noBtn: "لا"
    },
  },
  locationDisclaimer:{
    text:"لتجربه افضل، ادخل اللوكيشن",
    addAddressBtn : "اضف عنوان",
    skipBtn:"تخطي"
  },
  ...termsAndConditionsAr,
};
